import { Button } from '@pique/component';
import { posthog } from '@pique/core/posthog';
import { AudioLines } from 'lucide-react';
import type { MouseEvent, PropsWithChildren } from 'react';

import * as styles from './page-list-new-page-button.css';

export const PageListNewPageButton = ({
  className,
  children,
  testId,
  onCreateDoc,
}: PropsWithChildren<{
  className?: string;
  size?: 'small' | 'default';
  testId?: string;
  onCreateDoc: (e?: MouseEvent) => void;
  onCreatePage?: (e?: MouseEvent) => void;
  onCreateEdgeless?: (e?: MouseEvent) => void;
  onImportFile?: (e?: MouseEvent) => void;
}>) => {
  return (
    <div className={className} data-testid={testId}>
      <Button
        className={styles.newDocButton}
        onClick={(e: React.MouseEvent) => {
          onCreateDoc(e);
          posthog.track('doc_created', {
            control: 'new_doc_button',
            page: 'workspace',
            segment: 'doc_list',
            module: 'new_doc'
          });
        }}
        data-testid="new-doc-button"
      >
        <div className={styles.newPageButtonLabel}>{children}</div>

        <div className={styles.recordIconContainer}>
          <AudioLines className={styles.recordIcon} />
        </div>
      </Button>
    </div>
  );
};
